/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PlayerStatus {
    Undefined = 0,
    Recording = 1,
    Debriefing = 2,
    Ready = 3,
    Presentation = 5,
    LiveStream = 6,
    Preparing = 7,
    PreparingTraining = 8,
}
